<template>
  <div class="hospitalManage column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div class="width220">
          <el-input placeholder="库房名称" style="width: 100%;" clearable v-model="name"></el-input>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          搜索
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">清空</div>
        <div class="flex1"></div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickAdd" v-if="canOperate">新增库房</div>
      </div>
      <div class="column-me flex1 margin-top20">
        <div>
          <el-table :data="tableData" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style">
            <el-table-column prop="name" label="库房名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="mangerName" label="库房管理员" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" align="center" width="220" v-if="canOperate">
              <template v-slot="scope">
                <div class="row-me center-all">
                  <div class="blue-text" @click="clickEdit(scope.row)">修改</div>
                  <div class="blue-text margin-left30" @click="clickDelete(scope.row)">删除</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="margin-top20">
          <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增库房 -->
    <el-dialog title="新增库房" v-model="visibleEdit" width="50%" top="5vh" :destroy-on-close="true">
      <editStock :id="selectItem.id"></editStock>
    </el-dialog>
  </div>
</template>

<script>
import editStock from './editStock.vue'

export default {
  components: {
    editStock
  },
  data() {
    return {
      name: '',
      tableData: [],
      pageNo: 1,
      total: 0,
      visibleEdit: false,
      selectItem: {},
      canOperate: false,
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.pageNo = 1
    this.getData()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //搜索
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    //清空
    clickClear() {
      this.name = ''
      this.pageNo = 1
      this.getData()
    },
    //新增
    clickAdd() {
      this.selectItem = {}
      this.visibleEdit = true
      this.bus.$off('editHouseSuccess')
      this.bus.$on('editHouseSuccess', res => {
        this.visibleEdit = false
        this.pageNo = 1
        this.getData()
      })
    },
    //编辑
    clickEdit(item) {
      this.selectItem = this.$method.deepClone(item)
      this.visibleEdit = true
      this.bus.$off('editHouseSuccess')
      this.bus.$on('editHouseSuccess', res => {
        this.visibleEdit = false
        this.pageNo = 1
        this.getData()
      })
    },
    //删除
    clickDelete(item) {
      this.selectItem = this.$method.deepClone(item)
      this.$confirm("您确定要删除吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postRequest('/admin/pharmacy/delete', [item.id]).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.pageNo = 1
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //导出
    clickExport() {

    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/pharmacy/page', {
        name: this.name,
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.hospitalManage {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }
}
</style>
